import { render, staticRenderFns } from "./AnnouncementCard.vue?vue&type=template&id=5e2d3876&scoped=true"
import script from "./AnnouncementCard.vue?vue&type=script&lang=js"
export * from "./AnnouncementCard.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementCard.vue?vue&type=style&index=0&id=5e2d3876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2d3876",
  null
  
)

export default component.exports